import { render } from "./vpassThongKe.vue?vue&type=template&id=dcd28a32"
import script from "./vpassThongKe.vue?vue&type=script&lang=js"
export * from "./vpassThongKe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__